var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var _this = this;

import { createAction } from "typesafe-actions";
import { getPeerReviewInfo, postPeerReview, postSpamFlag } from "../../services/peerReviewService";
import { setQuizState } from "../user/actions";
export var set = createAction("peerReviews/SET", function (resolve) {
  return function (newState) {
    return resolve(newState);
  };
});
export var setReviewAnswer = createAction("peerReviews/SET_ANSWER", function (resolve) {
  return function (peerReview) {
    return resolve(peerReview);
  };
});
export var selectAnswer = createAction("peerReview/SELECT_ANSWER", function (resolve) {
  return function (quizAnswerId, userId, peerReviewCollectionId, questionIds) {
    return resolve({
      quizAnswerId: quizAnswerId,
      userId: userId,
      peerReviewCollectionId: peerReviewCollectionId,
      questionIds: questionIds
    });
  };
});
export var setReviewOptions = createAction("peerReviews/SET_OPTIONS", function (resolve) {
  return function (answerOptions) {
    return resolve(answerOptions);
  };
});
export var changeGradeAction = createAction("peerReviews/CHANGE_GRADE", function (resolve) {
  return function (peerReviewQuestionId, value, peerReviewCollection) {
    return resolve({
      peerReviewQuestionId: peerReviewQuestionId,
      value: value,
      peerReviewCollection: peerReviewCollection
    });
  };
});
export var changeTextAction = createAction("peerReviews/CHANGE_TEXT", function (resolve) {
  return function (peerReviewQuestionId, text, peerReviewCollection) {
    return resolve({
      peerReviewQuestionId: peerReviewQuestionId,
      text: text,
      peerReviewCollection: peerReviewCollection
    });
  };
});
export var changeGrade = function changeGrade(peerReviewQuestionId, value) {
  return function (dispatch, getState) {
    var peerReviewCollection = getState().quiz.peerReviewCollections.find(function (prc) {
      return prc.questions.some(function (q) {
        return q.id === peerReviewQuestionId;
      });
    });

    if (!peerReviewCollection) {
      console.log("No answer that matches the id of the reviewed answer");
      return;
    }

    dispatch(changeGradeAction(peerReviewQuestionId, value, peerReviewCollection));
  };
};
export var changeText = function changeText(peerReviewQuestionId, text) {
  return function (dispatch, getState) {
    var peerReviewCollection = getState().quiz.peerReviewCollections.find(function (prc) {
      return prc.questions.some(function (q) {
        return q.id === peerReviewQuestionId;
      });
    });

    if (!peerReviewCollection) {
      console.log("No answer that matches the id of the reviewed answer");
      return;
    }

    dispatch(changeTextAction(peerReviewQuestionId, text, peerReviewCollection));
  };
};
export var submit = function submit() {
  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var peerReview, accessToken, address, userQuizState;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            peerReview = getState().peerReviews.answer;

            if (!peerReview) {
              return [2];
            }

            accessToken = getState().user.accessToken;
            dispatch(setSubmitDisabled(true));
            address = getState().backendAddress;
            return [4, postPeerReview(peerReview, accessToken, address)];

          case 1:
            userQuizState = _a.sent().userQuizState;
            dispatch(setQuizState(userQuizState));
            dispatch(setReviewAnswer(null));
            return [4, dispatch(fetchPeerReviewAlternatives())];

          case 2:
            _a.sent();

            return [2];
        }
      });
    });
  };
};
export var selectAnswerToReview = function selectAnswerToReview(quizAnswerId) {
  return function (dispatch, getState) {
    var user = getState().user;

    if (!user) {
      console.log("user not set");
      return;
    }

    if (!user.userQuizState) {
      console.log("uqs not set");
      return;
    }

    var userId = user.userQuizState.userId;
    var prc = getState().quiz.peerReviewCollections[0];
    dispatch(selectAnswer(quizAnswerId, userId, prc.id, prc.questions.map(function (q) {
      return q.id;
    })));
  };
};
export var postSpam = function postSpam(quizAnswerId) {
  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var accessToken, address;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            accessToken = getState().user.accessToken;
            setReviewOptions([]);
            address = getState().backendAddress;
            return [4, postSpamFlag(quizAnswerId, accessToken, address)];

          case 1:
            _a.sent();

            return [4, dispatch(fetchPeerReviewAlternatives())];

          case 2:
            _a.sent();

            return [2];
        }
      });
    });
  };
};
export var fetchPeerReviewAlternatives = function fetchPeerReviewAlternatives() {
  return function (dispatch, getState) {
    return __awaiter(_this, void 0, void 0, function () {
      var accessToken, quiz, languageId, address, answerAlternatives;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            accessToken = getState().user.accessToken;
            quiz = getState().quiz;
            languageId = getState().language.languageId;
            address = getState().backendAddress;
            return [4, getPeerReviewInfo(quiz.id, languageId, accessToken, address)];

          case 1:
            answerAlternatives = _a.sent();
            dispatch(setReviewOptions(answerAlternatives));
            return [2];
        }
      });
    });
  };
};
export var setSubmitDisabled = function setSubmitDisabled(newValue) {
  return function (dispatch, getState) {
    dispatch(set(__assign({}, getState().peerReviews, {
      submitDisabled: newValue
    })));
  };
};
export var clear = createAction("peerReviews/CLEAR");